if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Generic copy for failures that carry no usable description: a network
        // error, or a non-JSON body such as Shopify's HTML 429 "Verifying your
        // connection…" page. Without it the spinner just stopped and nothing
        // told the shopper the add had failed.
        const genericError = (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';

        fetch(`${routes.cart_add_url}`, config)
          .then((response) =>
            response.json().catch(() => ({ status: response.status || 'error', description: null, message: null }))
          )
          .then((response) => {
            if (response.status) {
              // A member the shop isn't signed in as: sign the shop in and come
              // back (assets/scent-society-gate.js). Navigating, so no error UI.
              if (
                window.EBMembership &&
                window.EBMembership.recoverShopSignIn &&
                window.EBMembership.recoverShopSignIn(response.description)
              ) return;

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description || genericError,
                message: response.message,
              });
              this.handleErrorMessage(response.description || genericError);
              this.revealError();

              // Only an inventory refusal turns the button into "Sold out". Other
              // 422s (gift-card recipient fields, selling-plan, quantity rules) and
              // 429/5xx/network failures keep the button usable so the shopper can
              // fix the input or simply retry.
              const isStockError =
                response.status === 422 && /sold out|available|stock/i.test(response.description || '');
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!isStockError || !soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: genericError,
              message: genericError,
            });
            this.handleErrorMessage(genericError);
            this.revealError();
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // The error renders beside the in-page button, which is off-screen when the
      // add was started from the PDP sticky bar (it only shows once that button
      // has scrolled away). Bring whichever error is showing into view: the
      // gift-card recipient form's own summary when this form hides its errors,
      // else the wrapper above. Recipient errors also move focus to the first
      // invalid field so the shopper can fix it straight away.
      revealError() {
        const target = this.hideErrors
          ? this.querySelector('.product-form__recipient-error-message-wrapper:not([hidden])')
          : this.errorMessageWrapper && !this.errorMessageWrapper.hidden
          ? this.errorMessageWrapper
          : null;
        if (!target) return;
        const rect = target.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (this.hideErrors) {
          const invalid = this.querySelector('[aria-invalid="true"]');
          if (invalid) invalid.focus({ preventScroll: true });
        }
      }
    }
  );
}
